import React, { useEffect, useState } from "react";
import {
  Grid,
  CircularProgress,
  Typography,
  Button,
  TextField,
  Fade,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import getClient from "../../services/getClient";
import checkTokenService from '../../services/checkToken';
import { NineCellLoading } from 'react-loadingg';

import { ToastContainer, toast, Bounce } from "react-toastify";
import '../../components/Layout/ReactToastify.css';
import moment from "moment";

// styles
import useStyles from "./styles";
import '../landingPage/style.css';

// context
import { useUserDispatch, loginUser } from "../../context/UserContext";
import Cookies from "universal-cookie";

// Local
import ExpiredWidget from "../../widgets/ExpiredWidget";
import checkUtente from "../../services/checkUtente";
import translateString from "../../utils/Locales";
import resetUserPassword from "../../services/resetUserPassword";
import Utils from "../../utils/utils";

const qs = require('querystring');
let t = translateString;

function Login(props) {
  var classes = useStyles();

  // global
  var userDispatch = useUserDispatch();

  // local
  var [isLoading, setIsLoading] = useState(false);
  var [error, setError] = useState(null);
  var [loginValue, setLoginValue] = useState("");
  var [passwordValue, setPasswordValue] = useState("");
  var [logoImage, setLogoImage] = useState('');
  var [expiredFreeVersion, setExpired] = useState(false);
  var [showExpiredWidget, showExpired] = useState(false);
  var [db, setDb] = useState(null)
  var [update, runUpdate] = useState(false);

  var logoUrl;
  const cookies = new Cookies();
  var dab = '';

  useEffect(() => {

    dab = window.location.href.split('/')[3];
    if (dab.includes('#')) dab = dab.slice(0, -1);
    cookies.set('db', dab, { path: '/'});
    cookies.set('db_path', dab, { path: '/' });
    setDb(dab);

    Utils.setAnalyticsPage('Login ' + dab);

    if (window.location.hash.includes('#/login?')) {
      const parsed = qs.parse(window.location.hash);

      cookies.set('username', parsed['#/login?username'], { path: '/' });
      cookies.set('token', parsed['token'], { path: '/' });

      loadLogo(parsed['#/login?username'], parsed['token']);
    } else {
      loadLogo('', '');
    }
  }, []);

  const loadLogo = async (username, token) => {

    const db = cookies.get('db', { path: '/' });
    const client = await getClient(username, token, db);
    
    if (client != null) {
      const startDate = moment(client.startDate, "DD/MM/yyyy");
      const endDate = startDate.add(30, 'days');
      const today = moment().startOf('day');
      
      let check = false;
      var rem = moment.duration(endDate.diff(today)).asDays();
      console.log(rem);
      if (rem < 0 && client.is_expirable === '1') {
        setExpired(true);
        check = true;
      } 
      logoUrl = client.logoImage;
      setLogoImage(logoUrl);
      setIsLoading(false);


      let res = await checkTokenService(username, token);
      if (res) {
        let user = await checkUtente(username, token, username);
        if (user[0] !== null && !check) {
          setLoginValue(user[0].username);
          setPasswordValue(user[0].clear_password);
          setIsLoading(true);
          await loginUser( userDispatch, user[0].username, user[0].clear_password, dab, props.history, setIsLoading, setError );
        } else {
          showExpired(true)
        }
      }
    }
  };

  const handleReset = async () => {
    
    if (loginValue.trim() === '') {
        Utils.showError(t('errore_res'));
        return;
    } 

    var d = "";
    d = window.location.href.split('/')[3];
    if (d.includes('#')) d = d.slice(0, -1);

    await resetUserPassword(loginValue, d, t('language_string'));
    toast.info(t('reset_fatto'), {
      hideProgressBar: true, 
      autoClose: 10000,
      closeOnClick: true, 
      pauseOnHover: false,
      transition: Bounce,
      closeButton: false,
      toastId: 'toast_1304_i',
      
    });;
  }

  const handleLogin = async () => {
    if (!expiredFreeVersion) {
      await loginUser(
          userDispatch,
          loginValue,
          passwordValue,
          db,
          props.history,
          setIsLoading,
          setError,
        )
      } else {
        showExpired(true);
      }
  }

  if (isLoading) return <NineCellLoading />
  else return (
    <Grid container className={classes.container}>
      <ToastContainer />
      { !showExpiredWidget && (
        <div className={classes.logotypeContainer}>
          <img alt="" src={logoImage ? logoImage : require('../../images/icon.png')} style={{width: '40%'}} />
        </div>  
      )}
      { !showExpiredWidget && (
      <div className={classes.formContainer}>
        <div className="lang-btn" style={{ position: 'fixed', top: 30, right: 60 }} onClick={() => { runUpdate(!update); window.sessionStorage.setItem('lang', 'it') }}><img src={ require('../../images/it.png') } style={{ width: 20, height: 'auto' }}/></div>
        <div className="lang-btn" style={{ position: 'fixed', top: 30, right: 30 }} onClick={() => { runUpdate(!update); window.sessionStorage.setItem('lang', 'en') }}><img src={ require('../../images/en.png') } style={{ width: 20, height: 'auto' }}/></div>
        <div className={classes.form}>
            <React.Fragment>
              <Typography variant="h1" className={classes.greeting}>
                {t('benvenuti')}
              </Typography>
              <Fade in={error}>
                <Typography color="secondary" className={classes.errorMessage}>
                  {t('controlla_credenziali')}
                </Typography>
              </Fade>
              <TextField
                id="email"
                InputProps={{
                  classes: {
                    underline: classes.textFieldUnderline,
                    input: classes.textField,
                  },
                }}
                value={loginValue}
                onChange={e => setLoginValue(e.target.value)}
                margin="normal"
                placeholder="Username"
                type="text"
                onKeyDown={async (e) => e.key === 'Enter' && handleLogin()}
                fullWidth
              />
              <TextField
                id="password"
                InputProps={{
                  classes: {
                    underline: classes.textFieldUnderline,
                    input: classes.textField,
                  },
                }}
                value={passwordValue}
                onChange={e => setPasswordValue(e.target.value)}
                margin="normal"
                placeholder="Password"
                type="password"
                onKeyDown={async (e) => e.key === 'Enter' && handleLogin()}
                fullWidth
              />
              <div className={classes.formButtons}>
                {isLoading ? (
                  <CircularProgress size={26} className={classes.loginLoader} />
                ) : (
                  <div>
                    <Button
                      disabled={
                        loginValue.length === 0 || passwordValue.length === 0
                      }
                      onClick={() => {
                          handleLogin()
                        }}
                      variant="contained"
                      color="primary"
                      size="large"
                    >
                      {t('accedi')}
                    </Button>
                    <div style={{ cursor: 'pointer', color: '#4C73F7', marginTop: 15 }} onClick={() => handleReset()}>{t('password_dimenticata')}</div>
                  </div>
                )}
              </div>
            </React.Fragment>
        </div>
        <Typography color="primary" className={classes.copyright}>
          © 2021-{moment().format('yyyy')} APPIUS. All rights reserved.
        </Typography>
      </div>
      )}
      { showExpiredWidget && (
        <ExpiredWidget /> 
      )}
    </Grid>
  );
}

export default withRouter(Login);
